export default "__VITE_ASSET__9b73a67c__"